/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-22 14:36:11
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-23 23:02:47
 */

import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 获取收货地址列表
     */
    getList:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/address/1/pageList`,
            method: 'post',
            data,
        })
    },
    add:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/address/1/save`,
            method: 'post',
            data,
        })
    },
    update:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/address/1/update`,
            method: 'post',
            data,
        })
    },
    deleteAddress:(params)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/address/1/delete/${params.id}`,
            method: 'get',
            params,
        })
    },
    getDetail:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/address/1/detail`,
            method: 'post',
            data,
        })
    },
    /**
     * 获取收货人列表
     */
    getpersonList:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/consignee/1/getPageList`,
            method: 'post',
            data,
        })
    },
    /**
     * 新增取货人
     */
    saveAddressPerson:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/consignee/1/saveModel`,
            method: 'post',
            data,
        })
    },
    /**
     * 修改取货人
     */
    updateAddressPerson:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/consignee/1/updateModel`,
            method: 'post',
            data,
        })
    },
    /**
     * 删除取货人
     */
    deleteAddressPerson:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/consignee/1/deleteById`,
            method: 'post',
            data,
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/modules/address.js